import Consts from '../../consts/clientConsts'
import DaxContact from './DaxContact';
import Contact from './Contact';

import { v4 as uuidv4 } from 'uuid';
import Tma from './Tma';

export default class {

    constructor(dto) {
        let isExist = dto != null;
        let isFromServer = isExist ? typeof(dto.MdRetailChainId) == "string" : null;
        
        this.Id = isExist ? dto.Id : null;
        this.AccountNum = isExist ? dto.AccountNum : null;
        this.AccountName = isExist ? dto.AccountName : null;
        this.DateLastInvoice = isExist ? dto.DateLastInvoice : null;
        this.DaxId = isExist ? dto.DaxId : null;
        this.Branch = isExist ? dto.Branch : null;
        this.Region = isExist ? dto.Region : null;
        this.DateModified = isExist ? dto.DateModified : new Date();

        let defaultLocation = { Latitude: 0, Longitude: 0 };

        this.Location = isExist
                            ? dto.Location 
                                ? dto.Location
                                : defaultLocation
                            : defaultLocation;

        this.MdRetailChainId = isExist 
                                    ? isFromServer 
                                        ? dto.MdRetailChainId == "Сеть"
                                            ? true
                                            :false
                                        : dto.MdRetailChainId
                                    : null;
        
        this.MdRetailChainName = isExist ? dto.MdRetailChainName : null;
        this.Address = isExist ? dto.Address : null;

        this.SubType = isExist
                            ? isFromServer 
                                ? Consts.TradePointSubType.find(e => e.Text == dto.SubType)
                                : dto.SubType
                            : null;

        this.Type = isExist 
                        ? isFromServer 
                            ? Consts.TradePointType.find(e => e.Id == dto.Type)
                            : dto.Type
                        : null;

        this.IsPriceMonitoring = isExist ? dto.IsPriceMonitoring : false;

        this.AverageSales = isExist ? dto.AverageSales : 0;
        this.AverageSize = isExist ? dto.AverageSize : 0;
        this.AverageSku = isExist ? dto.AverageSku : 0;
        this.MmlSales = isExist ? dto.MmlSales : 0;

        this.SegmentCode = isExist
                                ? isFromServer 
                                    ? Consts.SegmentCodes.find(e => e.Id == dto.SegmentCode)
                                    : dto.SegmentCode
                                : Consts.SegmentCodes[1];

        this.Segment = isExist
                            ? dto.Segment
                            : null;

        this.Format = isExist ? dto.Format : null;
        this.RetailChainCode = isExist ? dto.RetailChainCode : null;
        this.MagnitSignalDate = isExist ? dto.MagnitSignalDate : new Date();
        this.AepList = isExist ? dto.AepList : [];
        this.MagnitSignalList = isExist ? dto.MagnitSignalList : [];

        this.ContactList = isExist                            
                                ? dto.ContactList.map(e => new Contact().mapFromDto(e))                                
                                : [];

        this.DaxContactList = isExist
                                ? isFromServer
                                    ? dto.DaxContactList.map(e => new DaxContact().mapFromDto(e))
                                    : dto.DaxContactList
                                : [];

        this.TodoList = isExist
                            ? isFromServer
                                ? dto.TodoList.map(e => new Todo().mapFromDto(e))
                                : dto.TodoList
                            : [];

        this.TmaList = isExist && dto.TmaList && dto.TmaList.length
                ? dto.TmaList.map(e => new Tma().mapFromDto(e))
                : [];

        this.RecommendationList = isExist ? dto.RecommendationList : [];
        this.RecommendationTaskList = isExist ? dto.RecommendationTaskList : [];
    }

    showTask(task) {
        if(!task.IsActive)
            this.TodoList.map(e => e.IsActive = false);

        task.IsActive = !task.IsActive;
    }

    isValidName() {
        return Boolean(this.MdRetailChainName);              
    }

    isValidType() {
        return Boolean(this.Type);
    }

    isValidSegment() {
        return Boolean(this.SegmentCode)
    }

    isInValidDaxContactsName() {
        return this.DaxContactList.some(e => e.Name == "" || e.Name == null);
    }

    isInValidDaxContactsRights() {
        return this.DaxContactList.some(e => e.Type == null);
    }

    mapToDto() {

        if(!this.Id)
            this.Id = uuidv4();

        this.DaxContactList.forEach(el => {
            if(!el.Id)
                el.Id = uuidv4();
            
            if(!el.TradePointId)
                el.TradePointId = this.Id;
        });

        let result = JSON.parse(JSON.stringify(this));

        result.SubType = result.SubType ? result.SubType.Text : null;
        result.Type = result.Type ? result.Type.Id : null;
        result.SegmentCode = result.SegmentCode.Id;
        result.TodoList = result.TodoList.map(e => this.mapTaskToDto(e));
        
        result.DaxContactList.forEach(e => {
            e.Type = e.Type.Id;
        });

        result.MdRetailChainId = result.MdRetailChainId ? 'Сеть' : 'Не сеть';

        return result;
    }

    mapTaskToDto(task) {
        let result = {
            Id: null,
            Status: null,
            Text: null,
            DataCreated: null,
            DateFinished: null,
            PlannedFinishDate: null,
            ChangeDate: null,
            TradePointId: null,
            Creator: {},
            Finisher: {},
            Category: {}
        };

        result.Id = task.Id;
        result.Status = task.Status.Id;
        result.Text = task.Text;
        result.DataCreated = task.DataCreated;
        result.DateFinished = task.DateFinished;
        result.PlannedFinishDate = task.PlannedFinishDate;
        result.ChangeDate = task.ChangeDate;
        result.TradePointId = task.TradePointId;
        result.Creator = task.Creator;
        result.Finisher = task.Finisher;
        result.Category = task.Category;

        return result;
    }
}

class Todo {
    Id = null;

    Status = null;

    Text = null;

    DataCreated = null;
    MonthDateCreatedString = null;
    HoursDateCreatedString = null;

    DateFinished = null;

    PlannedFinishDate = null;
    PlannedFinishDateString = null;

    ChangeDate = null;

    TradePointId = null;

    Creator = null;
    Finisher = null;

    Category = null;

    AvatarLetter = '?';
    IsCompleted = false;
    StatusText = null;
    StatusImagePath = null;
    StatusColor = null;

    IsActive = false;

    mapFromDto(todoDto) {
        if(!todoDto)
            return this;

        this.Id = todoDto.Id;
        this.Status = Consts.TaskStatus.find(e => e.Id == todoDto.Status);
        this.Text = todoDto.Text;

        this.DataCreated = new Date(todoDto.DataCreated);
        this.MonthDateCreatedString = this.getDateString(this.DataCreated);
        this.HoursDateCreatedString = this.getTimeString(this.DataCreated);

        this.DateFinished = todoDto.DateFinished;

        this.PlannedFinishDate = todoDto.PlannedFinishDate;
        this.PlannedFinishDateString = this.getDateString(new Date(this.PlannedFinishDate));

        this.ChangeDate = todoDto.ChangeDate;

        this.TradePointId = todoDto.TradePointId;

        this.Finisher = todoDto.Finisher;
        this.Creator = todoDto.Creator;
        
        if(this.Creator && !this.Creator.FullName)
            this.Creator.FullName = "Неизвестно";

        this.AvatarLetter = this.Creator.FullName[0];

        this.Category = todoDto.Category 
                            ? todoDto.Category 
                            : { Id: "00000000-0000-0000-0000-000000000000", FullName: "Неизвестно" };

        this.IsCompleted = this.Status.Id == 2;
        this.StatusText = this.IsCompleted ? "Выполнено" : "Не выполнено";
        this.StatusImagePath = this.IsCompleted ? '/img/done.png' : '/img/undone.png';
        this.StatusColor = this.IsCompleted ? 'done' : 'undone';

        return this;
    }

    mapToDto() {
        let todo = JSON.parse(JSON.stringify(this));

        let todoDto = {
            Id: todo.Id,
            Status: 2,
            Text: todo.Text,
            DateCreated: todo.DataCreated,
            DateFinished: todo.DateFinished,
            PlannedFinishDate: todo.PlannedFinishDate,
            ChangeDate: todo.ChangeDate,
            TradePointId: todo.TradePointId,
            Creator: todo.Creator,
            Finisher: todo.Finisher,
            Category: todo.Category
        };

        return todoDto;
    }

    getDateString(value) {
        return `${value.getDate()} ${Consts.months.find(e => e.Id == value.getMonth()).Text}`;
    }

    getTimeString(value) {
        let hours = `${value.getHours()}`.length == 1 
                        ? `0${value.getHours()}`
                        : value.getHours();

        let minutes = `${value.getMinutes()}`.length == 1 
                        ? `0${value.getMinutes()}`
                        : value.getMinutes();

        return `${hours}:${minutes}`;
    }
}